"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
class DeploymentsApi extends _basic_data_hub_api.default {
  async deleteDeployment(deployment) {
    return this._callApi({
      path: `/deployments/${deployment.id}`,
      queryParams: {},
      method: 'delete'
    });
  }

  // lockDeployment ({id, force}) {
  //     return Promise.try(() => Vue.http.get(`${this.deploymentsLockUrl}/${id}`, _.merge({params : {force}}, this.headers)))
  //         .then(response => response.json());
  // }

  async getDeploymentById(id, projection) {
    return this._callApi({
      path: `/deployments/${id}`,
      queryParams: {
        projection
      },
      method: 'get'
    });
  }
  async getDeployments(_ref) {
    let {
      query = {},
      projection
    } = _ref;
    query.dateDeactivated = 0;
    return this.getAllDeployments({
      query,
      projection
    });
  }
  async getAllDeployments(_ref2) {
    let {
      query = {},
      projection,
      limit,
      offset,
      group
    } = _ref2;
    return this._callApi({
      path: `/deployments`,
      queryParams: {
        projection,
        query,
        limit,
        offset,
        group
      },
      method: 'get'
    });
  }
  getActiveDeployments(projection) {
    return this.getDeployments({
      projection
    });
  }
  getDeploymentsByBotId(botId, projection) {
    return this.getDeployments({
      query: {
        botId
      },
      projection
    });
  }
  getAllDeploymentsByBotId(botId, projection) {
    return this.getAllDeployments({
      query: {
        botId
      },
      projection
    });
  }
  getActiveDeploymentsByBotId(botId, projection) {
    return this.getDeployments({
      query: {
        botId
      },
      projection
    });
  }
  getDeploymentsByFlowId(flowId, projection) {
    return this.getDeployments({
      query: {
        flowId
      },
      projection
    });
  }
  getAllDeploymentsByFlowId(flowId, projection) {
    return this.getAllDeployments({
      query: {
        flowId
      },
      projection
    });
  }
  getActiveDeploymentsByFlowId(flowId, projection) {
    return this.getDeployments({
      query: {
        flowId
      },
      projection
    });
  }
  async saveDeployment(deployment) {
    deployment.id = deployment.id || 'new';
    const res = await this._callApi({
      path: `/deployments/${deployment.id}`,
      queryParams: {},
      payload: {
        deployment
      },
      method: 'post'
    });
    return this.setDiff(deployment, res);
  }

  // unlockDeployment ({id, lockId}) {
  //     return Promise.try(() => Vue.http.delete(`${this.deploymentsLockUrl}/${id}`, _.merge({params : {lockId}}, this.headers)))
  //         .then(response => response.json());
  // }
}
var _default = DeploymentsApi;
exports.default = _default;